import React from 'react';
import { Button, Grid, Box } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { getTabsByParent } from "../utils/menuBuilder";

/**
 * DynamicTabs Component
 * Automatically renders tabs based on child modules in modulesDetails.
 * @param {string} parentUrl - The URL of the page containing the tabs. If not provided, it detects from current path.
 */
const DynamicTabs = ({ parentUrl }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { modules } = useAuth();
  
  const currentPath = location.pathname.toLowerCase();
  
  // Logic to find tabs:
  // 1. Find the module corresponding to current path. 
  //    If multiple (parent and tab share URL), prefer the one that IS a child so we can find its parent.
  const currentModule = modules.find(m => 
    m.moduleUrl?.toLowerCase() === currentPath && m.parentModuleId
  ) || modules.find(m => m.moduleUrl?.toLowerCase() === currentPath);

  // 2. Determine the parent identifier (ID or URL).
  const effectiveParent = parentUrl || currentModule?.parentModuleId || currentModule?.moduleUrl || currentPath;
  
  const tabs = getTabsByParent(modules, effectiveParent);
  if (tabs.length === 0) return null;

  return (
    <Box sx={{ width: '100%', mb: 2 }}>
      <Grid
        container
        spacing={1}
        sx={{
          background: "#F5F8FF",
          margin: "10px 0",
          width: "100%",
          borderRadius: "5px",
          padding: "10px",
          fontWeight: 600,
          display: "flex",
          flexWrap: "nowrap",
          overflowX: "auto", // Allow scrolling for many tabs
          "&::-webkit-scrollbar": { display: "none" }, // Hide scrollbar
          msOverflowStyle: "none",
          scrollbarWidth: "none",
        }}
      >
        {tabs.map((tab) => {
          const isActive = currentPath === tab.moduleUrl?.toLowerCase();
          return (
            <Grid item key={tab._id}>
              <Button
                variant="contained"
                size="medium"
                sx={{
                  whiteSpace: "nowrap",
                  margin: "5px",
                  fontWeight: "inherit",
                  background: isActive ? "#33499F" : "#D2F0F4",
                  color: isActive ? "#fff" : "#000000",
                  "&:focus": { outline: "none" },
                  "&:hover": { color: "white", background: "#33499F" },
                }}
                onClick={() => navigate(tab.moduleUrl)}
              >
                {tab.moduleName}
              </Button>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default DynamicTabs;
